import AsyncSearchMultiSelect from './AsyncSearchMultiSelect'

export default AsyncSearchMultiSelect
